import React from 'react'
import RemoveUserFromOrganization from 'src/app/RemoveUserFromOrganization/RemoveUserFromOrganization'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { removeUserFromOrganizationRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const RemoveUserFromOrganizationAppRoute: AppRoute = {
  id: AppLocation.RemoveUserFromOrganization,
  routeProps: removeUserFromOrganizationRouteProps,
  component: <RemoveUserFromOrganization />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default RemoveUserFromOrganizationAppRoute
